import { render, staticRenderFns } from "./HomeBanners.vue?vue&type=template&id=5a80ac5d&scoped=true&"
import script from "./HomeBanners.vue?vue&type=script&lang=js&"
export * from "./HomeBanners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a80ac5d",
  null
  
)

export default component.exports